// Copyright (c) 2020 Deere & Company

import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../actions-list';
import {getDefaultState} from '../state/';

const updateProduct = (state, action) =>
Product.update(state, {
    $set: action.details
});

const resetProduct = () => getDefaultState().product;

const actionTypes = {
    [actions.UPDATE_PART_COVERAGE_SEARCH_PRODUCT_SUCCESS]: updateProduct,
    [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetProduct,
    [actions.RESET_PART_COVERAGE_SEARCH_ADDITIONAL_INFORMATION]: resetProduct
};

export default (state = getDefaultState().product, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/product.js